/* eslint-disable array-callback-return */
/* eslint-disable guard-for-in */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
import { takeLatest, select, putResolve, call } from 'redux-saga/effects';
import safeUuidv4 from '../../utils/safeUuid';
import _findKey from 'lodash/findKey.js';
import _findIndex from 'lodash/findIndex.js';
import keyBy from 'lodash/keyBy.js';
import get from 'lodash/get.js';
import find from 'lodash/find.js';
import _findLast from 'lodash/findLast.js';
import {
  CREATE_DESIGN_START,
  CREATE_CONFIG_START,
  CREATE_ITEM_START,
  CREATE_ITEM_PRODUCT_START,
} from '../../actions/designActions/actionTypes';
import {
  createDesignSuccess,
  createDesignFailed,
  createItemSuccess,
  createItemDetailsSuccess,
  createItemFailed,
  createItemProductSuccess,
  createItemProductFailed,
  createContainerSuccess,
  createConfigSuccess,
  createConfigurationFailed,
  isAllDone,
} from '../../actions/designActions';
import safeSaga from '../safeSaga';
import {
  designSelector,
  orderSummarySelector,
  thdStoreInfoSelector,
  configuratorSelector,
  productDetailsSelector,
} from '../../selectors';
import { patchDesign, addItemProduct } from '../../services/pipfiguratorService';
import { isHomeDelivery } from '../../utils/isHomeDelivery';
import { createConfigurationForPpe } from '../../api/configuratorSettings';
import { trackStashInteractions, trackErrorInteractions } from '../../utils/analytics/trackEvents';
import toCartFulfillmentMethod from '../../actions/cartActions/__toCartFulfillmentMethod';
import {
  recordPpeCreateDesignFailure,
  recordPpeCreateItemFailure,
  recordPpeCreateConfigurationFailure,
  recordPpeCreateItemProductFailure,
} from '../../utils/newRelic';
import getExpConfig from '../../utils/getExpConfig';
import { getThumbnailUrl } from '../../utils/lineItemUtils';

export function* createDesign() {
  const { storeNumber } = yield select(thdStoreInfoSelector);
  const defaultContainerName = 'Container 1';
  const designId = safeUuidv4();
  const containerId = safeUuidv4();
  const ppeWearableProductLineId = 24;
  const newDesign = {
    designId,
    name: 'Design 1',
    productLine: ppeWearableProductLineId,
    zip: '',
    storeNumber: Number(storeNumber),
  };
  const newContainer = {
    containerId,
    name: defaultContainerName,
    containerType: '0',
  };
  const designPayload = {
    design: newDesign,
    containers: [newContainer],
  };

  try {
    const response = yield call(patchDesign, designPayload);
    yield putResolve(createContainerSuccess(newContainer.containerId));
    yield putResolve(createDesignSuccess(response.design));
    trackStashInteractions('stash', 'cart addition info');
  } catch (err) {
    yield putResolve(createDesignFailed(err.response && err.response.data));
    recordPpeCreateDesignFailure(err, designId, containerId, storeNumber);
  }
}

export function* createItem({ payload }) {
  const { containerId } = payload;
  const design = yield select(designSelector);
  const { orderSummaryItems } = yield select(orderSummarySelector);
  const { designId } = design;
  const newItemPayload = [];
  for (let i = 0; i < orderSummaryItems.length; i++) {
    newItemPayload.push({
      designId,
      itemId: safeUuidv4(),
      label: `pipfigurator ${i}`,
      itemSource: 'Autobahn',
      containerId,
      isDeleted: false,
      attributes: [],
      quantity: orderSummaryItems[i].quantity,
    });
  }

  const designPayload = {
    design,
    containers: [],
    items: [...newItemPayload],
  };

  try {
    const response = yield call(patchDesign, designPayload);
    const currentItems = response.items;
    for (let count = 0; count < currentItems.length; count++) {
      const newItem = currentItems[count];
      yield putResolve(createItemSuccess(newItem));
    }
  } catch (err) {
    yield putResolve(createItemFailed(err.response && err.response.data));
    recordPpeCreateItemFailure(err, designId, containerId, orderSummaryItems);
  }
}

const buildHiddenOption = (key, value, options, choices) => {
  const matchingOptionId = _findKey(options, { internalName: key });
  const matchingChoiceId = _findKey(choices, { optionId: +matchingOptionId });
  return {
    optionId: +matchingOptionId,
    choiceId: +matchingChoiceId,
    choiceValue: value,
    optionType: options[matchingOptionId].optionType,
    optionTags: options[matchingOptionId].tags,
  };
};

const customSelector = (data) => {
  let hiddenOptionData = {};
  const customSelected = {};
  const filterData = {};

  for (let i = 0; i < data.length; i++) {
    if (typeof data[i].choiceValue === 'object') {
      hiddenOptionData = data[i].choiceValue;
    }
  }

  for (const option in hiddenOptionData) {
    filterData[option] = Object.entries(hiddenOptionData[option]);
  }

  for (const key in filterData) {
    filterData[key].map((val) => {
      if (val[0] !== 'colorData') {
        if (key in customSelected) {
          customSelected[key].push(val);
        } else {
          customSelected[key] = [val];
        }
      }
    });
  }

  for (const key in customSelected) {
    customSelected[key] = Object.fromEntries(customSelected[key]);
  }

  return JSON.stringify(customSelected);
};

const OPTION_INTERNAL_NAME_PART_NUMBER = 'Manufacturer_Part_Number';
const CHOICE_INTERNAL_NAME_PART_NUMBER = 'Part_Number';
const buildHiddenSOOption = (options, choices, manufacturerPartNum) => {
  const mpnOption = find(
    options,
    (option) => option.internalName === OPTION_INTERNAL_NAME_PART_NUMBER
  );
  const optionId = get(mpnOption, 'id', null);
  const mpnChoice =
    optionId && find(choices, (choice) => choice.internalName === CHOICE_INTERNAL_NAME_PART_NUMBER);
  const choiceId = get(mpnChoice, 'id', null);
  const choiceValue = manufacturerPartNum || null;
  return { optionId, choiceId, choiceValue };
};

export function* createConfiguration() {
  const { orderSummaryItems } = yield select(orderSummarySelector);
  const { choices, options } = yield select(configuratorSelector);
  const {
    uploadImages: { uploadImages },
    config,
  } = yield select();
  const { storeNumber } = yield select(thdStoreInfoSelector);
  const { attributes } = yield select(productDetailsSelector);
  const size = orderSummaryItems.length;
  const items = orderSummaryItems;
  const configs = [];

  const presets = uploadImages
    .filter((img) => img.uploadedImageUrl)
    .map(
      ({
        enableRemoveBackground,
        id,
        isImageLoading,
        showUploadRemoveButton,
        toggleRemoveBackground,
        uploadedImageFileName,
        imagePlacement,
        uploadedImageUrl,
        ...item
      }) => item
    );
  let presetsObject = presets && keyBy(presets, 'uploadImageTabName');
  let displayLogoLocations = `${presetsObject.Front ? 'Front, ' : ''}${
    presetsObject.Back ? 'Back, ' : ''
  }${presetsObject.Left ? 'Left, ' : ''}${presetsObject.Right ? 'Right, ' : ''}`;
  displayLogoLocations = displayLogoLocations.substring(0, displayLogoLocations.length - 2);
  if (attributes?.ppeProductType === 'vest') {
    presetsObject = {
      ...(presetsObject.Front && {
        frontLogo: {
          logoColors: presetsObject.Front.logoColors,
        },
      }),
      ...(presetsObject.Back && {
        backLogo: {
          logoColors: presetsObject.Back.logoColors,
        },
      }),
    };
  } else {
    presetsObject = JSON.stringify({
      ...(presetsObject.Front && {
        frontLogo: {
          logoPlacement: presetsObject.Front.imagePlacementValue,
          logoSize: presetsObject.Front.imageSize,
        },
      }),
      ...(presetsObject.Back && {
        backLogo: {
          logoPlacement: presetsObject.Back.imagePlacementValue,
          logoSize: presetsObject.Back.imageSize,
        },
      }),
      ...(presetsObject.Left && {
        leftLogo: {
          logoPlacement: presetsObject.Left.imagePlacementValue,
          logoSize: presetsObject.Left.imageSize,
        },
      }),
      ...(presetsObject.Right && {
        rightLogo: {
          logoPlacement: presetsObject.Right.imagePlacementValue,
          logoSize: presetsObject.Right.imageSize,
        },
      }),
    });
  }

  try {
    let kCount = 0;
    while (kCount < size) {
      const { selections, base, baseCost, costKey, unit, pricingId, s3LiquidPixelUrl, sku } = items[kCount];
      let editedImgs = '';
      Object.keys(s3LiquidPixelUrl).forEach((prop) => {
        const img = s3LiquidPixelUrl[prop].split('/');
        editedImgs = `${editedImgs}${img[img.length - 1]},`;
      });

      if (editedImgs[editedImgs.length - 1] === ',') {
        editedImgs = editedImgs.substring(0, editedImgs.length - 1);
      }

      const manufacturerPartNumberOption = buildHiddenSOOption(options, choices, sku.sku);
      const hiddenOptions = [
        buildHiddenOption('LogoLocations', editedImgs, options, choices),
        buildHiddenOption('DisplayLogoLocations', displayLogoLocations, options, choices),
        buildHiddenOption('Folder_Path', `${getExpConfig('amazon-s3-environment-path')}Purchased/${pricingId}`, options, choices),
        buildHiddenOption('Logo_Presets', presetsObject, options, choices),
        {
          ...manufacturerPartNumberOption,
          optionType: options[manufacturerPartNumberOption.optionId].optionType,
          optionTags: options[manufacturerPartNumberOption.optionId].tags,
        },
      ];
      if (attributes?.ppeProductType === 'vest') {
        const logoPresetOptionId = _findKey(options, { internalName: 'Logo_Presets' });
        const logoPresetIndex = _findIndex(hiddenOptions, { optionId: +logoPresetOptionId });
        hiddenOptions[logoPresetIndex].choiceValue = customSelector(hiddenOptions);
      }
      const selectedAndHiddenOptions = [...selections, ...hiddenOptions];
      const img = getThumbnailUrl(items[kCount].selections);
      configs.push(
        yield call(
          createConfigurationForPpe,
          selectedAndHiddenOptions,
          storeNumber,
          base,
          baseCost,
          costKey,
          unit,
          config,
          img,
        )
      );

      yield kCount++;
    }

    for (let i = 0; i < size; i++) yield putResolve(createConfigSuccess(configs[i]));
  } catch (err) {
    yield putResolve(createConfigurationFailed(err.response && err.response.data));
    recordPpeCreateConfigurationFailure(err, orderSummaryItems, storeNumber);
  }
}

export function* createItemProduct(payload) {
  const customData = payload.payload[0];
  const {
    orderSummary: { orderSummaryItems },
    cart: { fulfillmentMethod: reduxFM },
    thdStoreInfo: { storeNumber: localStoreId, zipcode: zipCode },
  } = yield select();

  const fulfillmentMethod = reduxFM ? toCartFulfillmentMethod(reduxFM) : 'ShipToStore';
  const responses = [];
  const itemDetails = [];
  if (orderSummaryItems.length === customData.length) {
    try {
      for (let i = 0; i < customData.length; i++) {
        const { designId } = customData[i];
        const { itemId } = customData[i];
        const { configurationGuid } = customData[i];
        responses.push(
          yield call(addItemProduct, {
            designId,
            itemId,
            payload: {
              configurationGuid,
            },
          })
        );

        itemDetails.push({
          itemId: orderSummaryItems[i].partnerProductId.toString(),
          configurationId: configurationGuid,
          quantity: orderSummaryItems[i].quantity,
          fulfillmentLocation: isHomeDelivery(fulfillmentMethod) ? zipCode : localStoreId,
          fulfillmentMethod,
          zipCode,
        });
      }
      for (let jCount = 0; jCount < responses.length; jCount++) {
        const item = responses[jCount].items[jCount];
        yield putResolve(createItemProductSuccess({ item }));
      }
      // update itemDetails to graphQL cart payload
      yield putResolve(createItemDetailsSuccess(itemDetails));
      yield putResolve(isAllDone(true, false));
    } catch (err) {
      const errorObject = {
        type: 'system',
        displayType: 'inline',
        pageSection: 'Cart Add',
        message: err.response.statusText || 'An Internal Error has Occurred',
        code: err.response.status || 'API did not respond',
      };
      trackErrorInteractions(errorObject, 'error', 'post page error');
      yield putResolve(createItemProductFailed(err.response && err.response.data));
      recordPpeCreateItemProductFailure(err, orderSummaryItems, localStoreId, zipCode, customData);
    }
  }
}

export default function* designSaga() {
  yield takeLatest(CREATE_DESIGN_START, safeSaga(createDesign));
  yield takeLatest(CREATE_ITEM_PRODUCT_START, safeSaga(createItemProduct));
  yield takeLatest(CREATE_CONFIG_START, safeSaga(createConfiguration));
  yield takeLatest(CREATE_ITEM_START, safeSaga(createItem));
}
